import React from 'react';

interface ILayoutContentProps {
	children: React.ReactNode;
	className?: string;
}

const LayoutContent: React.FC<ILayoutContentProps> = ({
	children,
	className,
}) => {
	return (
		<div
			className={`
					bg-backgroundGray
					border-[1.5px]
					rounded-3xl
					p-2 
					m-2

					md:rounded-lg 
					md:p-4
					md:h-fit
					
					lg:rounded-lg
					${className}`}
		>
			{children}
		</div>
	);
};

export { LayoutContent };
